import React from "react";

const DeviceSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14.156"
      height="11.325"
      viewBox="0 0 14.156 11.325"
    >
      <path
        id="laptop-solid"
        d="M13.8,9.2H8.439a.7.7,0,0,1-.724.708H6.37A.751.751,0,0,1,5.645,9.2H.354A.355.355,0,0,0,0,9.555v.354a1.42,1.42,0,0,0,1.416,1.416H12.74a1.42,1.42,0,0,0,1.416-1.416V9.555A.355.355,0,0,0,13.8,9.2ZM12.74,1.062A1.065,1.065,0,0,0,11.679,0h-9.2A1.065,1.065,0,0,0,1.416,1.062V8.493H12.74ZM11.325,7.078H2.831V1.416h8.493Z"
        fill="#9c4eea"
      />
    </svg>
  );
};

export default DeviceSVG;
